import get from "lodash/get";
import { Block } from "./Block";
import { Img } from "./Image";

export class Topic {
  constructor(node) {
    const modules = get(node, `modules`, []);
    this.title = get(node, `title`);
    this.ctaLayout = get(node, `ctaLayout`);
    this.longImage = get(node, `longImage`);
    this.mainImage = new Img(get(node, `mainImage`));
    this.modules =
      modules && modules.length ? modules.map((m) => new Block(m)) : [];
    this.sideBySide = get(node, `sideBySide`);
    this.slug = get(node, `slug`);
    this.squareImage = new Img(get(node, `squareImage`));
    this.subText = get(node, `subText.json`);
    this.subhead = get(node, `subhead`);
    this.topicPreview = get(node, `topicPreview.json`);
  }
}
